export type LastCopyIdAppState = Readonly<{ lastCopyId: string | null }>

export const selectLastCopyId = (s: LastCopyIdAppState): LastCopyIdAppState['lastCopyId'] => s.lastCopyId
